import {createEntitySlice} from 'utils/createEntitySlice';
import {ClientInsurance} from 'types/clientInsurance';
import {ClientInsuranceThunks} from './clientInsuranceThunks';

export interface ClientInsuranceState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  ClientInsurances: ClientInsurance[];
  pagy: any;
  ClientInsurance: ClientInsurance | null;
  isEditing: boolean;
  activeTab: string;
}

const initialState: ClientInsuranceState = {
  status: 'idle',
  error: null,
  ClientInsurances: [],
  ClientInsurance: null,
  pagy: {},
  isEditing: false,
  activeTab: 'All',
};
const ClientInsuranceSlice = createEntitySlice<ClientInsurance>({
  name: 'ClientInsurance',
  initialState,
  thunks: ClientInsuranceThunks,
  entityKey: 'ClientInsurance',
  entitiesKey: 'ClientInsurances',
  reducers: {},
});

export const {
  setEntity: setClientInsurance,
  setIsEditing,
  setActiveTab,
} = ClientInsuranceSlice.actions;
export {initialState as ClientInsuranceInitialState};
export default ClientInsuranceSlice.reducer;
